import React from 'react'
import { Button } from 'react-bootstrap'

const SyncFilmRating = ({ store, disabledEntityFromBatch }) => {
  return (<p><br />
    <strong>Steps:</strong>
    <ol>
      <li>Click "Fetch film ratings" button to fetch films latest ratings</li>
      <li>Chose overwrite or merge to save fetched changes</li>
    </ol>
    <Button onClick={() => store.syncFilmsRating()} disabled={!!disabledEntityFromBatch}>
      <span className='glyphicon glyphicon-cloud-download' /> Fetch film ratings
    </Button>
    <br />
  </p>)
}
export default SyncFilmRating
